/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";

import { Link } from "react-router-dom";

const FIELD_TO_PARAM = {
  rolename: "rolename",
  modulenames: "modulenames",
};

// material react table
import { MaterialReactTable } from "material-react-table";

//api url requirement
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import translation function for language translation
import { useTranslation } from "react-i18next";

const RolePriviledgeList = () => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  const {
    reloadRolePriviledgeList,
    setReloadRolePriviledgeList,
    setRolePriviledgeData,
    screenHeight,
  } = useContext(GlobalProvider);

  const [previledgeList, setPreviledgeList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterTimer = useRef(null);

  /* function to get all label data */
  const getAllPreviledgeList = async (currentColumnFilters = columnFilters) => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_ROLE_PRIVILEDGE + `?token=${token}`;

      currentColumnFilters.forEach(({ id, value }) => {
        const param = FIELD_TO_PARAM[id];
        if (param && value?.toString().trim()) {
          requestUrl += `&${param}=${encodeURIComponent(value.toString().trim())}`;
        }
      });

      const response = await getData(requestUrl);

      if (response.data) {
        setPreviledgeList(response.data);
        setResponseReceived(true);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* custom title html */
  const titleHtml = ({ dataItem }) => {
    return (
      <div className="title">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.rolename}</span>
          <Link
            to="#addUpdateRolePrevPopup"
            data-bs-toggle="offcanvas"
            className="ml-auto edit_icon"
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              onClick={() => {
                setRolePriviledgeData(dataItem._id);
              }}
            >
              edit
            </span>
          </Link>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (reloadRolePriviledgeList) {
      getAllPreviledgeList();
      setReloadRolePriviledgeList(false);
    }
  }, [reloadRolePriviledgeList]);

  /* hook to reload list */
  useEffect(() => {
    getAllPreviledgeList();
  }, []);

  /* column filter — debounced API call */
  useEffect(() => {
    clearTimeout(columnFilterTimer.current);
    columnFilterTimer.current = setTimeout(() => {
      getAllPreviledgeList(columnFilters);
    }, 500);
  }, [columnFilters]);

  const tableColumns = useMemo(
    () => [
      {
        id: "rolename",
        accessorKey: "rolename",
        header: t("Role"),
        Cell: ({ row }) => titleHtml({ dataItem: row.original }),
        size: 200,
      },
      {
        id: "modulenames",
        accessorKey: "modulenames",
        header: t("Previledge"),
        size: 200,
      },
    ],
    [previledgeList]
  );

  return (
    <div className="table-responsive">
      <MaterialReactTable
        columns={tableColumns}
        data={previledgeList}
        enableSorting
        enableFilters
        enableGlobalFilter={false}
        manualFiltering
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        onColumnFiltersChange={setColumnFilters}
        getRowId={(row) => row._id}
        state={{ rowSelection, columnFilters }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
        initialState={{
          pagination: { pageSize: 100, pageIndex: 0 },
          showColumnFilters: true,
        }}
      />
    </div>
  );
};

export default RolePriviledgeList;
